<template>
  <ButtonComponent :label="$t('createTask')" :icon="['fal', 'plus']" @click="$bus.$emit('task', { reference })" />
</template>

<script>
export default {
  props: {
    reference: Object,
  },
}
</script>
